import { InvoiceStatus, UNSUPPORTED_INVOICE_REPORT_STATUSES } from '../constants/invoices';
import { SingleInvoice } from '../services/InvoiceService';

export const downloadReport = (body: string, fileName: string) => {
  const blob = new Blob([body], { type: 'application/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
};

export const hideInvoiceReportButton = (invoice: SingleInvoice) => {
  // hide button for invoice statuses we don't support
  if (UNSUPPORTED_INVOICE_REPORT_STATUSES.includes(invoice.status as InvoiceStatus)) {
    return true;
  }

  const invoiceCreatedUtc = new Date(invoice.object_created).getTime(); // in ms
  const nowUtc = Date.now(); // in ms
  // this is  the date we start supporting itemized invoice download
  // Jan 1st 2022
  const startDateUtc = Date.UTC(2022, 0); // in ms

  // hidding button for invoices created in the last 24 hours + before Jan 1st 2022
  if (invoiceCreatedUtc < startDateUtc || nowUtc - invoiceCreatedUtc <= 1000 * 60 * 60 * 24) {
    return true;
  }

  return false;
};
